// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/book-check.js';

import { paths } from '../generated/book-check';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('book-check', Original, paths);
